import { useQuery } from 'react-query';

import {
    ApiResponse,
    QueryParams,
    ReportTemplate,
    getReportTemplateList as queryFn,
} from 'api/endPoints/GetReportTemplateList';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetReportTemplateList = (params: QueryParams) => {
    return useQuery<ApiResponse, QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getReportTemplateList', params],
        queryFn: () => queryFn(params),
        select: (data) => data.reports,
    });
};

export type QueryResponse = ReportTemplate;
